module.exports = __webpack_public_path__ + "static/full-power-program-white-bg-18ef988a8a0f1453583a5cabfb7326e6.jpg";